module.exports = __webpack_public_path__ + "media/images/knockout__pickarrow--inactive@3x-8d7c36e51597eadbcb5f335b3ff2de7f.png";